<template>
  <v-app>
    <TopBar v-if="this.$route.name !== 'Login'" />
    <SideBar v-if="this.$route.name !== 'Login'" />
    <v-main>
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </v-main>
  </v-app>
</template>

<script>
import TopBar from "./components/navigation/TopBar.vue";
import SideBar from "./components/navigation/SideBar.vue";

const delay = (ms) => new Promise((res) => setTimeout(res, ms));

export default {
  components: { TopBar, SideBar },
  name: "App",
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {},
  created() {
    this.$root.$on("reloadPage", async () => {
      this.isLoading = true;
      await delay(600);
      this.isLoading = false;
    });
  },
};
</script>
<style>
.spinner {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.2s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.text-area {
  padding-right: 10%;
}
.left-column {
  margin-left: 12%;
}
.right-column {
  margin-right: 12%;
}

html {
  scroll-behavior: smooth;
}
</style>